import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=380a1503"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380a1503')) {
      api.createRecord('380a1503', component.options)
    } else {
      api.reload('380a1503', component.options)
    }
    module.hot.accept("./Conversations.vue?vue&type=template&id=380a1503", function () {
      api.rerender('380a1503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Conversations.vue"
export default component.exports